import React, { useState } from 'react';

const servicos = [
  {
    tipo: 'mudanca',
    titulo: 'Mudança',
    descricao: 'Transporte de mudança com diferentes níveis de serviço.',
    detalhes: [
      { subtipo: 'Completa', descricao: 'Desmontagem, Embalagem, Empacotamento, Montagem, Transporte e Manuseio.' },
      { subtipo: 'Tradicional', descricao: 'Transporte e Manuseio.' },
      { subtipo: 'Econômica', descricao: 'Apenas Transporte.' }
    ]
  },
  {
    tipo: 'frete',
    titulo: 'Frete Express',
    descricao: 'Frete rápido para até 5 itens.',
    detalhes: null
  },
  {
    tipo: 'mercadoria',
    titulo: 'Mercadoria',
    descricao: 'Transporte de mercadorias de pequeno a médio porte.',
    detalhes: null
  },
  {
    tipo: 'veiculo',
    titulo: 'Veículo',
    descricao: 'Transporte exclusivo para veículos como moto ou carro.',
    detalhes: [
      { subtipo: 'Moto', descricao: 'Transporte exclusivo para motocicletas.' },
      { subtipo: 'Carro', descricao: 'Transporte exclusivo para automóveis.' }
    ]
  }
];

function EtapaTipoServico({ onNext, onBack, setDados, dados }) {
  const [selecionado, setSelecionado] = useState(dados.etapa3?.tipoServico?.tipo || '');
  const [subtipo, setSubtipo] = useState(dados.etapa3?.tipoServico?.subtipo || '');

  const servicoSelecionado = servicos.find((s) => s.tipo === selecionado);

  const podeAvancar = () => {
    if (!selecionado) return false;
    if (selecionado === 'mudanca' && !subtipo) return false;
    if (selecionado === 'veiculo' && !subtipo) return false;
    return true;
  };

  const avancar = () => {
    setDados((prev) => ({
      ...prev,
      etapa3: {
        tipoServico: {
          tipo: servicoSelecionado.tipo,
          titulo: servicoSelecionado.titulo,
          descricao: servicoSelecionado.descricao,
          subtipo: subtipo || null,
          detalhes: servicoSelecionado.detalhes
            ? servicoSelecionado.detalhes.find((d) => d.subtipo === subtipo)?.descricao || null
            : null
        }
      }
    }));

    console.log('Dados recebidos na etapa 3:', dados);
    onNext();
  };

  return (
    <div className="container">
      <h4 className="fw-semibold text-center mb-4" style={{ fontSize: '1.5rem', color: '#444' }}>
        Escolha o tipo de serviço
      </h4>

      <div className="row">
        {servicos.map((serv) => (
          <div
            key={serv.tipo}
            className="col-md-6 mb-4"
            onClick={() => setSelecionado(serv.tipo)}
          >
            <div
              className={`card h-100 shadow-sm p-3 ${selecionado === serv.tipo ? 'border-success border-2' : 'border-0'
                }`}
              style={{ cursor: 'pointer', transition: '0.3s' }}
            >
              <h5 className="card-title">{serv.titulo}</h5>
              <p className="card-text small">{serv.descricao}</p>

              {serv.tipo === selecionado && serv.detalhes && (
                <div className="mt-2">
                  <strong>
                    {serv.tipo === 'mudanca' ? 'Escolha o tipo de mudança:' : 'Tipo de veículo:'}
                  </strong>
                  {serv.detalhes.map((d) => (
                    <div className="form-check" key={d.subtipo}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="subtipo"
                        value={d.subtipo}
                        checked={subtipo === d.subtipo}
                        onChange={(e) => setSubtipo(e.target.value)}
                      />
                      <label className="form-check-label">
                        <strong>{d.subtipo}:</strong> {d.descricao}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={onBack}>
          Voltar
        </button>
        <button className="btn btn-success" onClick={avancar} disabled={!podeAvancar()}>
          Avançar
        </button>
      </div>
    </div>
  );
}

export default EtapaTipoServico;
